import React, { useState, useEffect } from 'react';
import { useSettings, useStore } from '../context/store';
import useGetPosts from '../methods/useGetPosts';

export default function LoadMore() {
	const { state, dispatch } = useStore();

	const settings = useSettings();

	const { getPosts } = useGetPosts();

	useEffect(() => {
		if (1 !== state.currentPage) {
			getPosts(settings.postsPerPage, false);
		}
	}, [state.currentPage]);

	function buttonClass() {
		let classString = '';

		if (true === state.loading) {
			classString = ' tf-load-more__button--loading';
		}

		return classString;
	}

	const showLoadMore = 
		state.pagesCount != state.currentPage && state.pagesCount > 1;

	if ('undefined' !== typeof state && showLoadMore) {
		const count =
			state.postsCount - settings.postsPerPage * state.currentPage;

		return (
			<div className="tf-load-more">
				<button
					className={`tf-load-more__button${buttonClass()}`}
					onClick={() =>
						dispatch({
							type: 'setCurrentPage',
							payload: state.currentPage + 1,
						})
					}
				>
					Load More ({count})
				</button>
			</div>
		);
	}
	return '';
}
